<template>
  <div>
    <div>
      <div class="breadcrumb-bar">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="fyd-body">
      <img src="../../assets/img.png" alt="" />
      <ul class="msgBox">
        <li @click="borrow" style="margin-right:10px">
          <div class="flex1">
            <p style="font-size: 21px">公有库新增书籍</p>
            <div>
              <div>
                <img src="" alt="" />
                <p style="color: #20c9ac"></p>
              </div>
              <p></p> 
            </div>
          </div>
          <div class="flex2">
            <el-button
              type="primary"
              style="height: 40px; width: 100px; border-radius: 16px"
              >领书</el-button
            >
            <div>
              <p style="float: right; font-size: 16px">已领取书籍</p>
              <p><span style="font-size: 48px">{{pickBookCount}}</span>本</p>
            </div>
          </div>
        </li>
        <li @click="buycourse"> 
           <div class="flex1">
            <p style="font-size: 21px">更多新增课程</p>
            <div>
              <div>
                <img src="" alt="" />
                <p style="color:#FC3400"></p>
              </div>
              <p></p>
            </div>
          </div>
          <div class="flex2">
            <el-button
              type="primary"
              style="height: 40px; width: 100px; border-radius: 16px"
              >了解详情</el-button
            >
            <div>
              <p style="float: right; font-size: 16px">已授权
                <span>{{authCourseCount}}
                </span>
                  套课程</p>
              <p><span style="font-size: 48px">{{authCourseCount}}</span>套</p>
            </div>
          </div>
        </li>
      </ul>
      <ul class="operBox">
        <li @click="addTeacher" >
          <div class="flex">
            <div>
              <img
                src="../../assets/icon.png"
                alt=""
                width="60px"
                height="60px"
                
              />
              <p style="font-size: 21px">添加老师</p>
            </div>
            <p style="font-size: 48px">{{teacherCount}}</p>
          </div>
          <p>
            教师作为本系统重要的管理员，利用本台，可以创
            建所开设的课程和承担的教学班级，生成一个课程 教学环境。
          </p>
        </li>
        <li @click="addStu">
          <div class="flex">
            <div>
              <img
                src="../../assets/icon2.png"
                alt=""
                width="60px"
                height="60px"
              />
              <p style="font-size: 21px">添加学员</p>
            </div>
            <p style="font-size: 48px">{{studentCount}}</p>
          </div>
          <p>学生用户是系统的主要用户，通常用户数非常多。</p>
        </li>
        <li @click="addClass">
          <div class="flex">
            <div>
              <img
                src="../../assets/icon1.png"
                alt=""
                width="60px"
                height="60px"
              />
              <p style="font-size: 21px">建立班级</p>
            </div>
            <p style="font-size: 48px">{{classCount}}</p>
          </div>
          <p>课程班级信息的内容包括：班级信息及学生名单。</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  components: {},
  data() {
    return {
      teacherCount:"",
      studentCount:'',
      classCount:'',
      pickBookCount:'',
      pubBookAddPercent:'',
      authCourseAddPercent:'',
      authCourseCount:''

    };
  },
  props: {},
  created() {
    this.initData()
  },
  computed: {},
  filters: {},
  mounted() {},
  watch: {},
  methods: {
    initData(){
        let params = {
        appId: this.$API.APPID,
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/other/fyd_homepage", params).then(
        (res) => {
          if (res != null) {
          var data = JSON.parse(res)      
        this.teacherCount = data.teacherCount //老师数量
        this.studentCount = data.studentCount//学员数量
        this.classCount = data.classCount//班级数量
        this.pickBookCount = data.pickBookCount//领取书籍数量
        this.pubBookAddPercent = data.pubBookAddPercent//最近一周公有书库书籍变化百分比，范围： -100.0 到 100.0
        this.authCourseAddPercent = data.authCourseAddPercent //最近一周授权课程变化百分比，范围： -100.0 到 100.0
        this.authCourseCount = data.authCourseCount//已授权课程数量
          
          }
        }
      );
    },
     addTeacher() {
      this.$router.push({
        name: "addTeacher",
      });
    },
     addStu() {
      this.$router.push({
        name: "addStu",
      });
    },
     addClass() {
      this.$router.push({
        name: "addClass",
      });
    },
    borrow(){
      this.$router.push({
        name: "borrow",
      });
    },
    buycourse(){
      this.$router.push({
        name: "buycourse",
      });
    },
      eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              if (
                address.indexOf("stu_save") == -1 &&
                address.indexOf("stu_del") == -1 &&
                address.indexOf("stu_update") == -1
              ) {
                resolve(JSON.stringify(response.data.data));
              } else {
                resolve(JSON.stringify(response.data.msg));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style.less";
.operBox {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  // margin-right: 22px;

  li {
    cursor: pointer;

    border-radius: 10px;
    background: #fff;
    width: 33%;

    padding: 10px;
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding: 12px;
      margin-bottom: 24px;
      img {
        margin-bottom: 27px;
      }
    }
  }
}
.msgBox {
  display: flex;
  // margin-right:10px;
  
  li {
    cursor: pointer;
    width: 50%;
    background: #fff;
    // margin-right: 10px;
    margin-top: 10px;
    padding: 20px;
    border-radius: 10px;
  }
  .flex1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .flex2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?f35697e6